import { Box, Typography } from "@material-ui/core";
import { styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const CustomCard = styled(Box)(({ theme }) => ({
  ".card": {
    background: "#FFFFFF",
    boxShadow: "0px 2px 14px 2px rgba(191, 197, 190, 0.25)",
    borderRadius: "14px",
    width: "300px",
    paddingBottom: "20px",
    textAlign: "center",
    cursor: "pointer",
    ".name": {
      fontSize: "22px",
      lineHeight: "160%",
      fontWeight: "700",
    },
    ".designation": {
      fontSize: "16px",
      lineHeight: "160%",
      fontWeight: "500",
    },
    img: {
      width: "300px",
    },
  },
  [theme.breakpoints.down("md")]: {
    ".card": {
      width: "130px",
      paddingBottom: "20px",
      ".name": {
        fontSize: "12px",
        lineHeight: "18px",
      },
      ".designation": {
        fontSize: "8px",
        lineHeight: "14px",
      },
      img: {
        width: "130px",
      },
    },
  },
}));

const Card = ({ details, handleClick }) => {
  return (
    <CustomCard>
      <Box
        className="card"
        // onClick={() => {
        //   handleClick();
        // }}
      >
        <LazyLoadImage
          src={details?.profile_img}
          alt={details?.name}
          effect="opacity"
        />
        <Typography className="name">{details?.name}</Typography>
        <Typography className="designation">{details?.designation}</Typography>
      </Box>
    </CustomCard>
  );
};
export default Card;
